import {LitElement} from 'lit';

export abstract class SpBaseInput<T> extends LitElement {
    abstract value: T;
    abstract disabled: boolean;

    emit<CustomPayload>(name: string, options?: CustomEventInit<CustomPayload>) {
        const event = new CustomEvent<CustomPayload>(name, {
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {} as CustomPayload,
            ...options
        });
        this.dispatchEvent(event);
        return event;
    }
}
